import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    container: {
        position: "relative",
        margin: 20,
        marginTop: 0,
    },
});

const InsightsSidePanelContainer = React.forwardRef<HTMLDivElement, { children: React.ReactNode }>(
    ({ children }, ref) => {
        const classes = useStyles();
        return (
            <div ref={ref} className={classes.container}>
                {children}
            </div>
        );
    }
);

export default InsightsSidePanelContainer;
